import { render, staticRenderFns } from "./PaymentCategory.vue?vue&type=template&id=488978e8"
import script from "./PaymentCategory.vue?vue&type=script&lang=js"
export * from "./PaymentCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports